exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fc .fc-daygrid-event-harness {\n    cursor: pointer !important;\n}\n", ""]);

// exports
